import { useCallback } from 'react';
import { ErrorPage } from '@/components/ErrorPage';
import { Programme, ProgrammePage } from '@edwin-group/cj-graphql';
import { Card } from './components/card';
import { useProgrammesList } from '../../hooks/useProgrammesList';
import { ProgrammeHero } from './components/hero';

export const ProgrammesList = () => {
  const { errors, page, programmes } = useProgrammesList();

  const header = useCallback(() => {
    return (
      <div className="pb-6">
        <ProgrammeHero page={page as ProgrammePage} />
      </div>
    );
  }, [page]);

  if (errors.length > 0) {
    console.error('ProgrammesListScreen', {
      ...errors,
    });
    return <ErrorPage error="Failed to load programmes" />;
  }

  if (!programmes || programmes.length === 0) {
    return (
      <div>
        {header()}
        <div className="py-8 text-center text-gray-500">No programmes available</div>
      </div>
    );
  }

  return (
    <div>
      {header()}
      <div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {programmes
            .filter((programme): programme is Programme => programme !== null)
            .map((programme) => (
              <Card
                key={programme.documentId}
                seeMissionButtonText={page?.seeMissionButton || ''}
                programme={programme as Programme}
              />
            ))}
        </div>
      </div>
    </div>
  );
};
